import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setFullScreenLoading } from "../../store/fullScreenLoaderSlice";
import { resetChatHistory } from "../../store/chatHistorySlice";
import { clearUserAccount } from "../../store/userAccountSlice";
import { logout } from "../../services/authService";
import { resetUserData } from "../../services/storageService";

const Logout = () => {
	const [apiError, setApiError] = useState(null);
	const dispatch = useDispatch();
	const navigate = useNavigate();

	useEffect(() => {
		document.title = "Logout - Jawab";

		const handleLogout = async () => {
			try {
				dispatch(setFullScreenLoading(true));
				const response = await logout();
				resetUserData();
				dispatch(resetChatHistory());
				dispatch(clearUserAccount());
				dispatch(setFullScreenLoading(false));

				navigate("/user/login");
			} catch (error) {
				resetUserData();
				// dispatch(setFullScreenLoading(false));
				setApiError(error.message || "Logout failed.");
				// window.location.href = "/";
			}
		};

		handleLogout();
	}, [navigate]);

	return (
		<div>
			{apiError && <div className="alert alert-danger text-center">{apiError}</div>}
		</div>
	);
};

export default Logout;